<template>
  <Plan
    is-highlighted
    title="Org Pro"
    description="Unlock the power of organizations and member management."
    :price="currentPrice"
    :price-description="`USD per ${interval}`"
    :features="FEATURES"
    :blocks="blocks"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import { computed } from '@nuxtjs/composition-api';
import Plan from './plan';
import { MEMBER_PRICES, PROFILE_PRICES, ORG_PRO } from './plans';

const FEATURES = [
  {
    title: 'All of the free features',
  },
  {
    title: 'Powerful member management tools. Control access to your profiles.',
  },
  {
    title: 'Get 2 members included with your plan',
  },
  {
    title: 'Powerful and versatile link types to keep your content fresh',
  },
  {
    title: 'In-depth analytics to track views, clicks, referral, geo and more',
  },
  {
    title:
      'Unlock premium integrations like Opt-in forms, Forms, Tracking Pixels, and more',
  },
  {
    title: 'Add your own domain to your profile for a custom URL',
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    interval: {
      type: String,
      default: 'month',
    },

    profiles: {
      type: Number,
      default: 1,
    },

    members: {
      type: Number,
      default: 1,
    },

    blocks: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const currentPrice = computed(() => {
      const profilePrice =
        PROFILE_PRICES[props.interval] *
        Math.max(props.profiles - ORG_PRO.numberOfProfiles, 0);
      const memberPrice =
        MEMBER_PRICES[props.interval] *
        Math.max(props.members - ORG_PRO.numberOfUsers, 0);

      return ORG_PRO.price[props.interval] + profilePrice + memberPrice;
    });

    return {
      FEATURES,
      currentPrice,
    };
  },
};
</script>

<style lang="scss" scoped></style>
